import React, { Component } from "react";
import PropTypes from "prop-types";
import styled, { css } from "styled-components";
import FieldRowWithTextInput from './FieldRowWithTextInput'
import { 
  queryGetBulkSmsAccount, 
  mutationCreateBulkSmsDraft,
  mutationUpdateBulkSmsDraft,
  queryGetBulkSmsCampaign,
  queryGetBulkSmsContactTagList,
  mutationTriggerSendCampaign
} from 'Apollo'
import { graphql, compose } from "react-apollo";
import '../../../node_modules/react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import Avatar from "module-common/Avatar";
import IconRaw from "module-common/Icon";
import LoadingPanel from "module-common/LoadingPanel";
import FieldRowWithDropdown from "./FieldRowWithDropdown";


export default compose(    
    graphql(queryGetBulkSmsAccount, {
        name: 'account'
    }),
    graphql(queryGetBulkSmsContactTagList, {
      name: 'tagList'
    }),
    graphql(mutationCreateBulkSmsDraft, {
      name: 'createDraft',
      refetchQueries: ['getBulkSmsCampaignList']
    }),
    graphql(mutationUpdateBulkSmsDraft, {
      name: 'updateDraft',
      refetchQueries: ['getBulkSmsCampaignList']
    }),
    graphql(queryGetBulkSmsCampaign, {
      name: 'smsDraft',
      skip: props => !props.isDraft,
      options: {
        fetchPolicy: 'network-only'
      }
    }),
    graphql(mutationTriggerSendCampaign, {
      name: 'triggerSendCampaign',
      refetchQueries: ['getBulkSmsCampaignList']
    })
)(
    class CreateCampaign extends Component {

        state = {
            campaignName: this.props.subject || '',
            content: this.props.title || '',
            selectedTagList: this.props.selectedTagList || [],
            isSending: false,
            campaignId: null,
            accountId: null
        }

        textFields = [
            {
                label: 'Campaign Name',
                stateName: 'campaignName'
            },
            {
                label: 'Content',
                stateName: 'content',
                type: 'textarea'
            }
        ]

        componentWillReceiveProps(nextProps) {
            const { account: { loading, getBulkSmsAccount }, smsDraft: { getBulkSmsCampaign } = {}  } = nextProps;
            if(getBulkSmsCampaign) {
              this.setState(state => ({
                ...state,
                campaignName: getBulkSmsCampaign.campaignName,
                content: getBulkSmsCampaign.content,
                selectedTagList: getBulkSmsCampaign.tagList
              }))
            }
        }

        onTriggerSendCampaign = async () => {
          const { account: { getBulkSmsAccount }, onSuccess, campaignId } = this.props
          let realCampaignId = campaignId
          try {
            if(!realCampaignId) {
              const { campaignName, content, selectedTagList } = this.state
              const result = await this.props.createDraft({
                variables: {
                  accountId: getBulkSmsAccount.id,
                  content: content,
                  campaignName: campaignName,
                  tagList: selectedTagList.map(item => item.id)
                },
                refetchQueries: ['getBulkSmsCampaignList', 'queryGetBulkSmsCampaignList']
              })
            
              realCampaignId = result.data.createDraft.id
            }
            if(realCampaignId) {
              this.setState(state => ({...state, isSending: true}))
              const result = await this.props.triggerSendCampaign({
                variables: {
                  campaignId: realCampaignId
                },
                refetchQueries: ['getBulkSmsCampaignList', 'queryGetBulkSmsCampaignList']
              })
              console.log(result)
              this.flushPanelData()
              if(onSuccess) onSuccess()
            }
          } catch(e) {
            console.log(e, "Error on updating / creating draft!")
          } finally {
            this.setState(state => ({...state, isSending: false}))
          }
          
        }

        onSave =  async () => {
          const { account: { getBulkSmsAccount }, onSuccess, campaignId } = this.props
          const { campaignName, content, selectedTagList } = this.state
          let result = null
          try {
            
            if(!campaignId) {
              this.setState(state => ({...state, isSending: true}))
              result = await this.props.createDraft({
                variables: {
                  accountId: getBulkSmsAccount.id,
                  content: content,
                  campaignName: campaignName,
                  tagList: selectedTagList.map(item => item.id)
                },
                refetchQueries: ['getBulkSmsCampaignList', 'queryGetBulkSmsCampaignList']
              })
              console.log(result)
            } else {
              this.setState(state => ({...state, isSending: true}))
              result = await this.props.updateDraft({
                variables: {
                  campaignId: campaignId,
                  content: content,
                  campaignName: campaignName,
                  tagList: selectedTagList.map(item => item.id)
                },
                refetchQueries: ['getBulkSmsCampaignList', 'queryGetBulkSmsCampaignList']
              })
            }
            this.flushPanelData()
            if(onSuccess) onSuccess()
          } catch(e) {
            console.log(e, "Error on updating / creating draft!")

          } finally {
            this.setState(state => ({...state, isSending: false}))
          }
          return result
        }
        

        flushPanelData = () => {
            this.setState(state => ({
                ...state,
                campaignName: '',
                content: '',
                tagList: [],
                campaignId: null,
                accountId: null,
                isSending: false
            }))
        }

        render() {
            const { tagList: { getBulkSmsContactTagList }, smsDraft: { getBulkSmsCampaign } = {} } = this.props
            const { isSending, selectedTagList } = this.state
            
            const tagListOptions = getBulkSmsContactTagList ? getBulkSmsContactTagList.map(item => ({
              label: item.displayName,
              value: item.id,
              selected: selectedTagList.find(existing => existing.id == item.id)
            })) : []
            return (    
            <WrapperPost>
                {isSending && <Overlay>
                    <LoadingPanel />
                </Overlay>}
                <Wrap>
                    <LeftColumn>
                        {this.textFields.map(({ label, stateName, type }) => {
                            return <FieldRowWithTextInput 
                                key={label}
                                label={label}
                                value={this.state[stateName]}
                                type={type || 'text'}
                                onChange={text => this.setState(state => ({...state, [stateName]: text }))}
                            />
                        })}
                        <FieldRowWithDropdown 
                          key="tagList"
                          label="Tag"
                          options={tagListOptions}
                          onChange={selected => {
                            this.setState(state => ({...state, selectedTagList: selected.map(item => ({ id: item.value }))}))
                          }}                       
                        />
                    </LeftColumn>
                    <RightColumn>
                            
                    </RightColumn>
                </Wrap>
                <Bottom>
                    <LeftBottom></LeftBottom>
                    <RightBottom>
                        <SendButton onClick={() => this.onSave() } >Save</SendButton>
                        <SendButton onClick={() => this.onTriggerSendCampaign() } >Send</SendButton>
                    </RightBottom>
                </Bottom>
            </WrapperPost>
            );
        }
    }
)


const Wrapper = styled.section`
  flex: 1;
  display: flex;
  flex-direction: row;
  box-shadow: none;
  background-color: #ebeef7;
  margin: -10px;
`;

const Overlay = styled.div`
  position: absolute;
  height: 100%;
  width: 100%;
  background-color: gray;
  opacity: 0.2;
  z-index: 99999;
  display: flex;
  justify-content: center;
  align-items: center;
`

const WrapperPost = styled.div`
  display: flex;
  flex: none;
  flex-direction: column;
  border-radius: 4px;
  border: 1px solid ${props => props.theme.panelBorder};
  margin: 5px 20px 10px;
  height: calc(70vh);
  position: relative;
`;
const WrapperSchedule = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  border-right: 1px solid ${props => props.theme.panelBorder};
`;
const Border = styled.div`
  display: flex;
  flex: 1;
  border-radius: 4px;
  overflow: hidden;
  background-color: ${props => props.theme.panelBackground};
  box-shadow: ${props => props.theme.shadow};
  margin: 10px;
  flex-direction: column;
  ${props => props.width && css`width: ${props.width};`}
`;
const WrapperAccount = styled.div`
  display: flex;
  margin-left: 10px;
  overflow-x: scroll;
`;


const Account = styled.div`
  display: flex;
  min-width: 120px;
  min-height: 30px;
  border-radius: 4px;
  /* border: 1px solid ${props => props.theme.panelBorder};
  background-color: #ebeef7; */
  margin-bottom: 8px;
  margin-left: 10px;
  cursor: pointer;
  &:hover {
    border: 1px solid ${props => props.theme.blueButton};
  }
  ${props => {
    if (props.selectedChannelStyle) {
      return css`
        border: 1px solid ${props => props.theme.blueButton};
        background-color: #fff;
      `;
    } else {
      return css`
        border: 1px solid ${props => props.theme.panelBorder};
        background-color: #ebeef7;
      `;
    }
  }};
`;

const Wrap = styled.section`
  position: relative;
  display: flex;
  flex-direction: row;
  /* border-top: 1px solid ${props => props.theme.panelBorder}; */
  border-bottom: 1px solid ${props => props.theme.panelBorder};
`;
const LeftColumn = styled.div`
  display: flex;
  flex: none;
  flex-direction: column;
  width: 45%;
  align-items: center;
  padding: 3px 20px 3px 20px;
`;
const RightColumn = styled.div`
  display: flex;
  flex-direction: column;
  width: 50%;
  padding: 10px 10px 0 10px;
`;
const StyledAvatar = styled(Avatar)`
  width: 30px;
  height: 30px;
`;
const Username = styled.div`
  line-height: 1.2;
  margin-bottom: 10px;
  color: rgba(0, 0, 0, 0.65);
`;
const Title = styled.div`
  font-weight: bold;
  margin-top: 10px;
  margin-bottom: 20px;
  padding-left: 20px;
`;

const Bottom = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  min-height: 50px;
  padding: 0 16px;
  align-items: space-between;
`;
const Signature = styled.span`
  font-size: 0.8rem;
  color: ${props => props.theme.uiText};
  margin-left: 4px;
  margin-top: 18px;
  margin-right: 20px;
`;
const Icon = styled(IconRaw)`
  margin-right: 10px;
`;
const SendButton = styled.button`
  display: flex;
  padding: 8px;
  align-items: center;
  justify-content: center;
  text-align: center;
  border: none;
  border-radius: 20px;
  color: white;
  transition: 0.3s;
  cursor: pointer;
  font-size: 0.8rem;
  padding: 5px 15px;
  margin-left: 10px;
  background-color: ${props => props.theme.blueButton};
  &:focus {
    outline: none;
  }
  &:hover {
    opacity: 0.7;
  }
`;

const HiddenFileInput = styled.input.attrs({
  type: "file",
  accept: "image/*"
})`
  width: 0.1px;
  height: 0.1px;
  opacity: 0;
  overflow: hidden;
  position: absolute;
  z-index: -1;
`;

const Span = styled.span`
  color: #338dca;
`;
const TextArea = styled.section`
  padding-top: 30px;
`;
const LeftBottom = styled.div`
  display: flex;
  margin-left: auto;
`;
const RightBottom = styled.div`
  display: flex;
`;



// WEBPACK FOOTER //
// ./src/module-bulk-sms/campaign/CreateCampaignWithQueryMutation.js